import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-http-error',
    templateUrl: './http-error.component.html',
    styleUrls: ['./http-error.component.scss'],
    standalone: false
})
export class HttpErrorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
